import React from "react";
import { Box } from "@mui/material";
import styles from "../styles/AdminMilestonesTracker.module.scss";
import MilestoneCard from "./MilestoneCard";

interface Milestone {
  patientProfileId: number;
  patientCaseId: number;
  actualDeliveryDate: string | null;
  actualDeliveryLocationId: number | null;
  tierClassificationId: number;
  tierDisplayName: string;
  tierSequence: number;
  rangeFrom: number | null;
  rangeTo: number | null;
  nextTierCheckpoint: number;
  redemptionStatusId: number;
  redemptionId: string | null;
  statusDisplayName: string;
  redemptionCouponCode: string;
  totalEarnedRewardPoints: number | null;
  validTill: string | null;
  color: string;
  tierMessage?: string;
}

interface AdminMilestonesTrackerProps {
  milestoneData: Milestone[];
}

const AdminMilestonesTracker: React.FC<AdminMilestonesTrackerProps> = ({
  milestoneData,
}) => {
  return (
    <Box className={styles.milestonesContainer}>
      {milestoneData.map((milestone, index) => (
        <MilestoneCard key={index} milestone={milestone} />
      ))}
    </Box>
  );
};

export default AdminMilestonesTracker;
